const routes = [
    {
        path: '/banco_inter/extratos',
        alias: '/banco_inter/extratos/index',
        component: () => import('../views/Listar')
    }
]

export default routes
